import lodash from 'lodash';
import {
    call, put, takeEvery, select, all,
} from 'redux-saga/effects';
// import { message } from 'antd';
import { LEAD_SOURCE_LEADOMATIC } from '../../../../../common/constants';
import { GET_LEAD_PAYMENT_APPROVAL_DATA, SET_LEAD_PAYMENT_APPROVAL_DATA } from '../../constants';
import { getLeads as getLeadsReq, countLeads as countLeadsReq } from '../../requests/getLeads.request';


function* getLeads({ isCount }) {
    const store = yield select();
    const userDivisions = lodash.get(store, 'App.App_content.user.divisions') || [];
    const divisionsIds = userDivisions.map((division) => division._id).filter((item) => item !== LEAD_SOURCE_LEADOMATIC);
    const { filters, pagination } = store.Leads.LeadPaymentApproval;

    yield put({
        type: SET_LEAD_PAYMENT_APPROVAL_DATA,
        payload: {
            isLoading: true,
            data: [],
        },
    });

    const requestParams = {
        limit: pagination.rpp,
        offset: pagination.offset,
        vrm: filters.vrm,
        waitingApproval: [filters.waitingApproval],
        ref_lead_source: divisionsIds,
    };

    const calls = {
        getLeadsRes: call(getLeadsReq, requestParams),
        countLeadsRes: isCount && call(countLeadsReq, requestParams),
    };

    const { getLeadsRes, countLeadsRes } = yield all(calls);

    const storePayload = {
        type: SET_LEAD_PAYMENT_APPROVAL_DATA,
        payload: {
            isLoading: false,
            data: getLeadsRes.result ? getLeadsRes.options : [],
            error: getLeadsRes.error,
        },
    };

    if (isCount) {
        storePayload.payload.dataCount = countLeadsRes.options.amount;
    }

    yield put(storePayload);
}

export default function* getLeadsSaga() {
    yield takeEvery(GET_LEAD_PAYMENT_APPROVAL_DATA, getLeads);
}



// WEBPACK FOOTER //
// ./src/modules/Leads/LeadPaymentApproval/redux/sagas/getLeads.saga.js